import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import React from 'react';
import CloseIcon from '../icons/CloseIcon';

export default function GenericSingleOptionalActionDialog({ open, title, subtitle, action = undefined, onClose }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiPaper-root': {
                    padding: 2,
                    borderRadius: 4,
                    whiteSpace: 'pre-line',
                },
            }}
        >
            <DialogTitle>
                <Typography variant="h3" component={'span'}>
                    {title}
                </Typography>
                <span onClick={onClose} style={{ position: 'absolute', right: 12, top: 12, cursor: 'pointer' }}>
                    <CloseIcon />
                </span>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">{subtitle}</Typography>
            </DialogContent>
            <DialogActions sx={{ alignSelf: 'center', marginBottom: '16px', marginTop: '16px' }}>
                {action !== undefined && (
                    <Button variant="contained" onClick={action.click}>
                        {action.label}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
